import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';

// Import AOS (Animate On Scroll)
import AOS from 'aos';
import 'aos/dist/aos.css'; 

import Header from './components/Header';
import Home from './components/Home';
import Footer from './components/Footer';
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Donate = lazy(() => import('./pages/Donate'));
const Checkout = lazy(() => import('./pages/Checkout'));
const Success = lazy(() => import('./pages/Success'));
const Failure = lazy(() => import('./pages/Failure'));
const Programs = lazy(() => import('./pages/Program'));
const Gallery = lazy(() => import('./pages/Gallary'));
const NewsroomPage = lazy(() => import('./pages/Newsroom'));
const NewsDetail = lazy(() => import('./pages/NewsDetail'));
const SocialGallery = lazy(() => import('./pages/SocialGallery'));
const HealthcareGallery = lazy(() => import('./pages/HealthcareGallery'));
const EducationGallery = lazy(() => import('./pages/EducationGallery'));
const GalleryDetail = lazy(() => import('./pages/GalleryDetail'));
const MyDonations = lazy(() => import('./pages/MyDonations'));
const Admin = lazy(() => import('./pages/Admin'));
const Legal = lazy(() => import('./pages/Legal'));
const Transparency = lazy(() => import('./pages/Transparency'));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    const titles = { '/': 'ALC Trust | Education, Health and Community Support', '/about': 'About ALC Trust', '/programs': 'Our Charitable Programmes | ALC Trust', '/transparency': 'Transparency and Registrations | ALC Trust', '/donate': 'Donate Securely | ALC Trust', '/contact': 'Contact ALC Trust', '/gallery': 'Impact Gallery | ALC Trust', '/newsroom': 'Newsroom | ALC Trust', '/my-donations': 'My Donations | ALC Trust', '/admin': 'Trust Administration | ALC Trust', '/privacy': 'Privacy Policy | ALC Trust', '/terms': 'Website and Donation Terms | ALC Trust', '/refund-policy': 'Donation Refund Policy | ALC Trust' };
    document.title = titles[pathname] || 'ALC Trust';
    const description = 'Support education, healthcare, food assistance and community welfare through Aturu Lakshumamma Charitable Trust.';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement('meta'); meta.name = 'description'; document.head.appendChild(meta); }
    meta.content = description;
  }, [pathname]);

  return null;
}

function App() {
  
  // Initialize scroll animations
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true,     
      offset: 100,    
      easing: 'ease-out-cubic',
    });
  }, []);

  return (
    <BrowserRouter>
      <CssBaseline />
      <ScrollToTop />
      <div className="App" style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
        <Header />
        <main style={{flex: 1}}>
          <Suspense fallback={<div role="status" style={{ padding: 48, textAlign: 'center' }}>Loading…</div>}><Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} />
            
            {/* Payment Flow Routes */}
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/success" element={<Success />} />
            <Route path="/failure" element={<Failure />} /> 
            <Route path="/my-donations" element={<MyDonations />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Legal type="privacy" />} />
            <Route path="/terms" element={<Legal type="terms" />} />
            <Route path="/refund-policy" element={<Legal type="refunds" />} />

            <Route path="/programs" element={<Programs />} />
            <Route path="/transparency" element={<Transparency />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/newsroom" element={<NewsroomPage />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/gallery/social" element={<SocialGallery />} />
            <Route path="/gallery/healthcare" element={<HealthcareGallery />} />
            <Route path="/gallery/education" element={<EducationGallery />} />
            <Route path="/gallery/:category/:id" element={<GalleryDetail />} />
          </Routes></Suspense>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
